// @ts-strict-ignore
import { Injectable } from "@angular/core";
import cloneDeep from "lodash-es/cloneDeep";
import merge from "lodash-es/merge";
import { ProfileDefaults } from "../models/profile.model";
import { DataService } from "./data.service";

@Injectable({ providedIn: "root" })
export class ProfileService {
  dataService = new DataService();

  generateProfileSettingsDefaults() {
    return cloneDeep(ProfileDefaults);
  }

  generateProfileSettings(profileJson) {
    // This simply starts with a default state and merges the incoming JSON into it, overriding shared  references.
    // Any deprecated references from the original source will still persist into the new object using this method.
    return merge(this.generateProfileSettingsDefaults(), profileJson);
  }
}
